import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as autoAssignApi from "../../api/autoAssignApi";

// Async thunks
// Async thunks
export const fetchConfig = createAsyncThunk(
  "autoAssign/fetchConfig",
  async (accountId, { rejectWithValue }) => {
    try {
      console.log("[Slice] Fetching config for:", accountId);
      const response = await autoAssignApi.getConfig(accountId);
      const result = response.data;
      console.log("[Slice] Fetch result:", result);

      if (result.status === 1) {
        return result.data;
      }
      return rejectWithValue(result.message);
    } catch (error) {
      console.error("[Slice] Fetch error:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "Có lỗi xảy ra",
      );
    }
  },
);

export const saveConfig = createAsyncThunk(
  "autoAssign/saveConfig",
  async (config, { rejectWithValue }) => {
    try {
      console.log("[Slice] Calling API with:", config);
      const response = await autoAssignApi.saveConfig(config);
      console.log("[Slice] API response:", response);
      // axios response.data is the server response
      const result = response.data;
      console.log("[Slice] Result:", result);
      if (result.status === 1) {
        return result.data;
      }
      return rejectWithValue(result.message);
    } catch (error) {
      console.error("[Slice] Error:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "Có lỗi xảy ra",
      );
    }
  },
);

const initialState = {
  config: null,
  loading: false,
  saving: false,
  error: null,
};

const autoAssignSlice = createSlice({
  name: "autoAssign",
  initialState,
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
    updateConfigLocal: (state, action) => {
      state.config = { ...state.config, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchConfig
      .addCase(fetchConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload;
      })
      .addCase(fetchConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // saveConfig
      .addCase(saveConfig.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(saveConfig.fulfilled, (state, action) => {
        state.saving = false;
        state.config = action.payload;
      })
      .addCase(saveConfig.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      });
  },
});

export const { resetError, updateConfigLocal } = autoAssignSlice.actions;
export default autoAssignSlice.reducer;
